module.exports = __webpack_public_path__ + "img/vision.a9f9b90a.svg";